import { useKnockSlackClient as h } from "../context/KnockSlackProvider.mjs";
import { useCallback as k } from "react";
import "../../i18n/context/KnockI18nProvider.mjs";
import "swr/infinite";
import { useKnockClient as p } from "../../core/context/KnockProvider.mjs";
import { TENANT_OBJECT_COLLECTION as _ } from "@knocklabs/client";
import "zustand/shallow";
import "date-fns";
const S = "https://slack.com/oauth/v2/authorize", u = ["chat:write", "chat:write.public", "channels:read", "groups:read"];
function E(s, a, r) {
  const e = p(), {
    setConnectionStatus: t,
    knockSlackChannelId: o,
    tenant: c,
    setActionLabel: i
  } = h(), l = r && r.length > 0 ? Array.from(new Set(u.concat(r))) : u, m = k(async () => {
    i(null), t("disconnecting");
    try {
      const n = await e.slack.revokeAccessToken({
        tenant: c,
        knockChannelId: o
      });
      t(n === "ok" ? "disconnected" : "error");
    } catch {
      t("error");
    }
  }, [t, e.slack, c, o, i]);
  return {
    buildSlackAuthUrl: k(() => {
      const n = {
        state: JSON.stringify({
          redirect_url: a,
          access_token_object: {
            object_id: c,
            collection: _
          },
          channel_id: o,
          public_key: e.apiKey,
          user_token: e.userToken
        }),
        client_id: s,
        scope: l.join(",")
      };
      return `${S}?${new URLSearchParams(n)}`;
    }, [a, c, o, e.apiKey, e.userToken, s, l]),
    disconnectFromSlack: m
  };
}
export {
  E as default
};
//# sourceMappingURL=useSlackAuth.mjs.map
